export const RPC_URL = 'http://159.65.118.250:7777/rpc';

export const NETWORK = 'casper-test';

export const CONTRACT_DID_HASH = "hash-daf3d4a5880aafc2078309602a7b211c1565fa9328d958fd655a50218fa8ea37";
export const CONTRACT_DEMOVCREGISTRY_HASH = "hash-167a36c35c0e63960b2633f370157ffd5fe577b66fe38cb79fc7962bca7837e2";

export const DEPLOY_GAS_PRICE = 10;
export const DEPLOY_GAS_PAYMENT = 50000000000;
export const DEPLOY_TTL_MS = 3600000;

export const DID_PREFIX = "did:casper";
